/**
 * Shared data-fetching primitives for the TanStack Query hook layer
 * (OPTIMISATION.md Phase 2 [G]).
 *
 * We keep our existing axios + getAuthHeaders + API_BASE plumbing (RQ is
 * transport-agnostic) and just forward RQ's AbortSignal to axios so queries
 * are cancelled automatically on unmount / key change.
 */
import axios from 'axios';
import { API_BASE } from '../../config/api';
import { getAuthHeaders } from '../../context/AuthContext';

/** GET `${API_BASE}${path}` with auth headers; forwards RQ's abort signal. */
export const apiGet = async (path, signal) => {
  const res = await axios.get(`${API_BASE}${path}`, { headers: getAuthHeaders(), signal });
  return res.data;
};

/**
 * Centralized query-key factory. Using these everywhere keeps invalidation
 * precise (mutations invalidate the narrowest key, e.g. qk.filmScenes(id)).
 */
export const qk = {
  workspaces: () => ['workspaces'],
  workspaceFilms: (id) => ['workspace', id, 'films'],
  workspaceUsage: (id) => ['workspace', id, 'usage'],
  workspaceActivity: (id, limit = 20) => ['workspace', id, 'activity', limit],
  workspaceMembers: (id) => ['workspace', id, 'members'],
  film: (id) => ['film', id],
  filmScenes: (id) => ['film', id, 'scenes'],
  filmMembers: (id) => ['film', id, 'members'],
  filmCast: (id) => ['film', id, 'cast'],
  filmCrew: (id) => ['film', id, 'crew'],
  filmEntitlements: (id) => ['film', id, 'entitlements'],
  scene: (id) => ['scene', id],
  sceneShots: (id) => ['scene', id, 'shots'],
  userFeatures: () => ['user', 'features'],
  userProfile: () => ['user', 'profile'],
  invitations: () => ['invitations'],
  workspaceInsights: (id, limit, refresh) => ['workspace', id, 'insights', limit, refresh],
};
